import React from 'react'
import { Button, Card, Flex, Tag, Typography } from 'antd'
import { LinkOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

import { LeadEntity } from '../../../domain/entities/Lead'

import './LeadCard.styles.css'

type LeadCardProps = {
  lead: LeadEntity
  loading?: boolean
  onProcess: (isTarget: boolean) => void | Promise<void>
}

const LeadCard: React.FC<LeadCardProps> = ({ lead, loading = false, onProcess }) => {
  const { t } = useTranslation()

  return (
    <Card
      className="lead-card"
      hoverable
      title={
        <Flex justify="space-between" align="center" gap={12} wrap>
          <Typography.Title level={5} className="lead-card-title">
            {lead.senderUsername ? `@${lead.senderUsername}` : t('unknown-sender', { ns: 'standard' })}
          </Typography.Title>
          {lead.topic && <Tag color="blue">{lead.topic}</Tag>}
        </Flex>
      }
      extra={
        <Typography.Link
          className="lead-card-link"
          href={lead.messageLink}
          target="_blank"
          rel="noreferrer"
        >
          <LinkOutlined />
          {t('open-original-message', { ns: 'standard' })}
        </Typography.Link>
      }
      actions={[
        <Button
          key="processed"
          color="green"
          variant="solid"
          loading={loading}
          onClick={() => onProcess(true)}
        >
          {t('lead-processed', { ns: 'standard' })}
        </Button>,
        <Button
          key="not-lead"
          danger
          loading={loading}
          onClick={() => onProcess(false)}
        >
          {t('lead-not-target', { ns: 'standard' })}
        </Button>
      ]}
    >
      <Typography.Paragraph className="lead-card-message">
        {lead.messageText}
      </Typography.Paragraph>
    </Card>
  )
}

export default LeadCard